import { render } from "./PasswordResetRequest.vue?vue&type=template&id=01590dcc&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=ts"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=ts"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=01590dcc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01590dcc"

export default script